export default __webpack_public_path__ + "static/media/pill.3dabaeee.svg";